import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';
import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';

const projectOrdersRoutes = [
  {
    path: 'orders',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Orders')
      },
      permissions: ['READ_ORDERS'],
      requiresComponents: ['CRM']
    },
    children: [
      {
        path: 'new',
        name: 'ordersListNew',
        component: () => asyncLoadView(import('pages/orders/ProjectOrdersPage/ProjectOrdersPage')),
        children: [
          {
            path: ':orderId(\\d+)',
            name: 'orderDetailsNew',
            component: () => asyncLoadView(import('pages/orders/ProjectOrdersPage/ProjectOrdersPage')),
            props: routeArgsToInt
          },
          {
            path: ':orderId(\\d+)/periods/:periodId(\\d+)',
            name: 'periodDetailsNew',
            component: () => asyncLoadView(import('pages/orders/ProjectOrdersPage/ProjectOrdersPage')),
            props: routeArgsToInt
          }
        ],
        props: routeArgsToInt
      },
      {
        path: '',
        name: 'ordersList',
        component: wrapLegacyRoute('ordersController', 'list')
      },
      {
        path: 'create',
        name: 'orderCreate',
        component: wrapLegacyRoute('ordersController', 'item')
      },
      {
        path: ':orderId(\\d+)',
        component: NestedRouteComponent,
        children: [
          {
            path: '',
            name: 'orderDetails',
            component: wrapLegacyRoute('ordersController', 'item')
          },
          {
            path: 'periods',
            component: NestedRouteComponent,
            children: [
              {
                path: '',
                name: 'orderPeriodsList',
                component: wrapLegacyRoute('orderPeriodsController', 'list')
              },
              {
                path: 'create',
                name: 'orderPeriodCreate',
                component: wrapLegacyRoute('orderPeriodsController', 'item')
              },
              {
                path: ':periodId(\\d+)',
                name: 'orderPeriodDetails',
                component: wrapLegacyRoute('orderPeriodsController', 'item')
              }
            ]
          }
        ]
      }

    ]
  }
];

export default projectOrdersRoutes;
